/**
* 倒计时 小插件
* @since 2018/11/7 12:39 create...
* @since 2019/6/3 18:17 update...
* @author FlyTiger
* */
(function (global, factory) {
    typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? (function(){ define(["jquery"],factory);global.countDown = factory();})() : (global.countDown = factory());
})(this, function () {
    var ___=window;
    //模板
    var $defaultTitle=["","",""];
    var $template="<span class='active-time pull-right'><div class='time_div'><div class='time_int_c time_d'></div><div class='time_hr'>Days</div></div><span><svg t='1730359759097' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5631'><path d='M512 292.205897c80.855572 0 146.358821-65.503248 146.358821-146.358821C658.358821 65.503248 592.855572 0 512 0 431.144428 0 365.641179 65.503248 365.641179 146.358821 365.641179 227.214393 431.144428 292.205897 512 292.205897zM512 731.282359c-80.855572 0-146.358821 65.503248-146.358821 146.358821 0 80.855572 65.503248 146.358821 146.358821 146.358821 80.855572 0 146.358821-65.503248 146.358821-146.358821C658.358821 796.273863 592.855572 731.282359 512 731.282359z' p-id='5632'></path></svg></span><div class='time_div'><div class='time_int_c time_h'></div><div class='time_hr'>Hours</div></div><span><svg t='1730359759097' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5631'><path d='M512 292.205897c80.855572 0 146.358821-65.503248 146.358821-146.358821C658.358821 65.503248 592.855572 0 512 0 431.144428 0 365.641179 65.503248 365.641179 146.358821 365.641179 227.214393 431.144428 292.205897 512 292.205897zM512 731.282359c-80.855572 0-146.358821 65.503248-146.358821 146.358821 0 80.855572 65.503248 146.358821 146.358821 146.358821 80.855572 0 146.358821-65.503248 146.358821-146.358821C658.358821 796.273863 592.855572 731.282359 512 731.282359z' p-id='5632'></path></svg></span><div class='time_div'><div class='time_int_c time_m'></div><div class='time_hr'>Minutes</div></div><span><svg t='1730359759097' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5631'><path d='M512 292.205897c80.855572 0 146.358821-65.503248 146.358821-146.358821C658.358821 65.503248 592.855572 0 512 0 431.144428 0 365.641179 65.503248 365.641179 146.358821 365.641179 227.214393 431.144428 292.205897 512 292.205897zM512 731.282359c-80.855572 0-146.358821 65.503248-146.358821 146.358821 0 80.855572 65.503248 146.358821 146.358821 146.358821 80.855572 0 146.358821-65.503248 146.358821-146.358821C658.358821 796.273863 592.855572 731.282359 512 731.282359z' p-id='5632'></path></svg></span><div class='time_div'><div class='time_int_c time_s'></div><div class='time_hr'>Seconds</div></div class='time_div'><div class='time_int_c time_ms'></div></span>";

    //事件
    var events={
        started:"countDownStarted",//开启
        ended:"countDownEnded",//结束
        restarted:"countDownRestarted"//重启
    };

    //常量池
    var GLOBAL_CONSTANTS={
        //毫秒倒计时分度
        MS_TIME_STEP:50,
        //秒倒计时分度
        SEC_TIME_STEP:1000,
        /*相对毫秒的时间计算常量*/
        //天计算常量
        DAY_STEP_MS:86400000,
        //小时计算常量
        HOUR_STEP_MS:3600000,
        //分钟计算常量
        MINUTE_STEP_MS:60000,
        //秒计算常量
        SEC_STEP_MS:1000
    };

    /**
     * 对100以内数字进行前面补0操作.
     * @param num
     * @returns {string}
     */
    var deal2=function (num) {
        return ((num / 10)|0) + "" + num % 10;
    };

    /**
     * 对1000以内数字进行3位补0
     * @param num
     * @returns {string}
     */
    var deal3 = function (num) {
        if(num<100){
            return '0'+deal2(num);
        }
        return ''+num;
    };

    /**
     * 时间毫秒值获取
     * @param time 初始化时间值:可选
     * @returns {number}
     */
    var getTime=function (time) {
        return (time?new Date(time):new Date()).getTime();
    };

    //方法
    var fns={
        //标题处理
        _title:function(){
            var _opts=this.opts;
            var $prefix=this.$timeEms_.$prefix,$suffix=this.$timeEms_.$suffix;
            if((_opts.title&&_opts.title.length)||(!_opts.prefix&&!_opts.suffix)){
                var _1= [].concat($defaultTitle);
                _1.splice(1,1,_opts.title||$defaultTitle[1]);
                $prefix.html(_1.join(""));
            }else{
                $prefix.html(_opts.prefix||"");
                $suffix.html(_opts.suffix||"");
            }
        },
        //初始化
        prepare:function(){
            fns._title.call(this);
            fns._f.call(this);
        },
        _f:function () {
            var _this=this;
            var time_end=this.opts.time_end||getTime();
            var _ems=this.$timeEms_;
            /** 如果需要MS,则倒计时频率为
             * @see #GLOBAL_CONSTANTS.MS_TIME_STEP
             * ,否则为
             * @see #GLOBAL_CONSTANTS.SEC_TIME_STEP
             * */
            var needms = this.opts.needms,timeStep = needms?GLOBAL_CONSTANTS.MS_TIME_STEP:GLOBAL_CONSTANTS.SEC_TIME_STEP;
            if(needms){
                this.$timeEms_.$ms.show();
            }else{
                this.$timeEms_.$ms.hide();
            }
            var f_=function _f(_time_end){
                var time_start = getTime(); //设定当前时间
                var time_end = getTime(_time_end); //设定目标时间
                // 计算时间差
                var time_distance = time_end - time_start;
                if(time_distance<1){
                    if(_this._timestamp_){
                        clearTimeout(_this._timestamp_);
                    }
                    _this._runing++;
                    _this.$container_.hide().triggerHandler(events.ended,[this.$container_,_this._runing,time_start]);
                    return false;
                }
                // 天
                var int_day = Math.floor(time_distance/GLOBAL_CONSTANTS.DAY_STEP_MS);
                time_distance -= int_day * GLOBAL_CONSTANTS.DAY_STEP_MS;
                // 时
                var int_hour = Math.floor(time_distance/GLOBAL_CONSTANTS.HOUR_STEP_MS);
                time_distance -= int_hour * GLOBAL_CONSTANTS.HOUR_STEP_MS;
                // 分
                var int_minute = Math.floor(time_distance/GLOBAL_CONSTANTS.MINUTE_STEP_MS);
                time_distance -= int_minute * GLOBAL_CONSTANTS.MINUTE_STEP_MS;
                // 秒
                var int_second = Math.floor(time_distance/GLOBAL_CONSTANTS.SEC_TIME_STEP);

                // 拆分各位和十位

                var int_day1 = Math.floor(int_day / 10);
                var int_day10 = int_day % 10;

                var int_hour1 = Math.floor(int_hour / 10);
                var int_hour10 = int_hour % 10;

                var int_minute1 = Math.floor(int_minute / 10);
                var int_minute10 = int_minute % 10;

                var int_second1 = Math.floor(int_second / 10);
                var int_second10 = int_second % 10;


                // 显示时间
                if(int_day1 != 0){
                    if(int_day10 != 0){
                        _ems.$d.css("display","none;")
                    }
                }
                _ems.$d.html("<div>"+int_day1+"</div><div>"+int_day10+"</div>");
                _ems.$h.html("<div>"+int_hour1+"</div><div>"+int_hour10+"</div>");
                _ems.$m.html("<div>"+int_minute1+"</div><div>"+int_minute10+"</div>");
                _ems.$s.html("<div>"+int_second1+"</div><div>"+int_second10+"</div>");



                // _ems.$d.html("<div class='time_nm'><div>"+int_day1+"</div></div><div class='time_nm'><div>"+int_day10+"</div></div>");
                // _ems.$h.html("<div class='time_nm'><div>"+int_hour1+"</div></div><div class='time_nm'><div>"+int_hour10+"</div></div>");
                // _ems.$m.html("<div class='time_nm'><div>"+int_minute1+"</div></div><div class='time_nm'><div>"+int_minute10+"</div></div>");
                // _ems.$s.html("<div class='time_nm'><div>"+int_second1+"</div></div><div class='time_nm'><div>"+int_second10+"</div></div>");


                if(needms){
                    //毫秒
                    var int_ms = time_distance -int_second*GLOBAL_CONSTANTS.SEC_TIME_STEP;
                    int_ms = deal3(int_ms);
                    _ems.$ms.html(int_ms);
                }

                // 设置定时器
                if(_this._timestamp_){
                    clearTimeout(_this._timestamp_);
                }
                _this._timestamp_=setTimeout(function (_) {
                    _f(_);
                },timeStep,_time_end);
            };
            if(this._runing){
                this.$container_.triggerHandler(events.restarted,[this.$container_,this._runing]);
            }else{
                this.$container_.triggerHandler(events.started,[this.$container_,this._runing]);
            }
            this.$container_.show();
            f_(time_end);
        }
    };
    /*
       * @param $container 倒计时容器
       * @param $opts 参数{title,prefix,suffix,time_end,needms},title优先级最高,needms默认为false,设置为true时,倒计时包含毫秒倒计时位.
       * */
        var CountDown=function ($container,$opts) {
            this.opts=$opts||{};
            $container=$container.empty().html($template).addClass("payment-time");
            // 显示时间
            this.$timeEms_={
                $d:$(".time_d",$container),
                $h:$(".time_h",$container),
                $m:$(".time_m",$container),
                $s:$(".time_s",$container),
                $ms : $(".time_ms",$container),
                $prefix:$(".time_prefix",$container),
                $suffix:$(".time_suffix",$container)
            };
            this.$container_=$container;
            this._runing=0;//标识初始执行
            //初始化
            fns.prepare.call(this);
            $(".active-time").before("<div>1111</div>");
        };

        //重新设置参数
        CountDown.prototype.setOpts=function($opts){
            this.opts=$.extend(this.opts, $opts||{});
            this._runing++;
            fns.prepare.call(this);
        };

        //绑定事件
        CountDown.prototype.on=function () {
             ___.jQuery.fn.on.apply(this.$container_,arguments);
             if(this._runing<1){
                 this.$container_.triggerHandler(events.started,[this.$container_,this._runing]);
             }
             return this;
        };
        //解除事件
        CountDown.prototype.off=function () {
              ___.jQuery.fn.off.apply(this.$container_,arguments);
            return this;
        };

    return function($container,$opts){
        if(!___.jQuery){
            throw new Error("jQuery is required for this plugin");
        }
        if(!$container||!$container.length){
            throw new Error("The container you given is not useful!");
        }
        return new CountDown($container,$opts);
    }
});
